<script>
import Layout from '@/Shared/Layout'
export default {
  layout: Layout,
}
</script>

<script setup>
import { onMounted, onUnmounted, reactive, provide ,ref} from 'vue'
import { Link } from '@inertiajs/inertia-vue3'
import { formatYen, filterOnlyUnique, replaceSpecials } from '@/Shared/helper.js'
import DetailPanel from '@/Pages/Brand/V2Components/DetailV2ProductDetailPanel'
import ExtendProductVideo from '@/Pages/Brand/ExtendProductVideo'
import Breadcrumbs from '@/Shared/Breadcrumbs'
import Icon from '@/Shared/Icons/Icon'

const props = defineProps({
  brandInfo: Array,
  myCategories: Object,
  myCategoriesColumns: Object,
  v3year: String,
  v3category: String,
  myProducts: Array,
  pref: Object,
})

provide('data', props.brandInfo[0])
const currentProducts = reactive({
  menustats: false,
  focus: -1,
  index: -1,
})
const getCategoryName = function (slug) {
  const l = props.myCategories[props.v3year].filter((i) => i.slug == slug)
  return l[0].name
}
// join s3 path from DB and productImage
const generateImgPath = function (img) {
  const r = props.brandInfo[0].brandPMSs3path + props.v3year + '/500/' + img
  return r
}
const generateIconImgPath = function (img) {
  const r = props.brandInfo[0].brandPMSs3path + props.v3year + '/' + img
  return r
}
const generateSubCategories = function () {
  let r = []
  let t = []
  const subcategories = props.myProducts.filter((i) => i.productYear == props.v3year && i.productCategoryMain == props.v3category && i.productCategorySub != '')
  subcategories.forEach((item) => {
    t.push(item.productCategorySub)
  })
  if (t.length >= 1) {
    r = t.filter(filterOnlyUnique)
  }
  return r
}
const scrollToAnchor = function (anchor) {
  var el = document.querySelector('#' + replaceSpecials(anchor))
  el.scrollIntoView({ behavior: 'smooth', block: 'start' })
}
const filterProductByYearAndCategory = function () {
  const subcategories = props.myProducts.filter((i) => i.productYear == props.v3year && i.productCategoryMain == props.v3category)
  return subcategories
}
const filterProductByYearAndCategoryAndSub = function (sub) {
  const subcategories = props.myProducts.filter((i) => i.productYear == props.v3year && i.productCategoryMain == props.v3category && i.productCategorySub == sub)
  return subcategories
}
// without subcategories
const focusItem = function (n) {
  currentProducts.focus = n
}
// with subcategories
const focusItemWithGroup = function (n, g) {
  currentProducts.focus = n
  currentProducts.index = g
}
// without subcategories
const matchIndex = function (a, b) {
  const r = a === b ? true : false
  return r
}
// with subcategories
const matchIndexWithGroup = function (a, b, g) {
  const r = a === b && currentProducts.index == g ? true : false
  return r
}

const checkNew = (productNewFlag) => {
  const r = productNewFlag.includes('NEW') ? true : false
  return r
}

const checkMips = (productNewFlag) => {
  const r = productNewFlag.includes('mips') ? true : false
  return r
}
const checkD3o = (productNewFlag) => {
  const r = productNewFlag.includes('d3o') ? true : false
  return r
}

const closePanel = function(){
  scrollToElement('.each-v4.active', 'smooth')
  currentProducts.focus = -1
}

const scrollToElement = function (target, behavior = 'instant') {
  var el = document.querySelector(target)
  el.scrollIntoView({ 
    block: 'start',
    behavior: behavior,
  })
}

const timer = ref(null)
const scrollToElementWithDelay = function(element, behavior = 'instant'){
  if (typeof window === 'undefined') return
  timer.value = setTimeout(function () {
    scrollToElement(element, behavior)
  }, 100)
}

onMounted(() => {})
onUnmounted(() => {
  clearTimeout(timer)
})
</script>

<template>
  <div id="brandDetail_v2" class="product_detail">
    <div class="contentsContainer">
      <Breadcrumbs class="!flex !m-0 w-full" category="brand" :slug="props.brandInfo[0].brandSlug" :title="props.brandInfo[0].brandNameLocal" />

      <div class="brand-products product-advance-wrap">
        <header>
          <h1 class="category-title" v-html="getCategoryName(v3category)" />
        </header>
        
        <!-- <ul v-if="generateSubCategories().length >= 1" class="subcategories">
          <li v-for="subcate in generateSubCategories()" :key="subcate">
            <ButtonRounded class="subcategories-btn" :text="subcate" @click="scrollToAnchor(subcate)" />
          </li>
        </ul> -->

        <section v-if="generateSubCategories().length >= 1" class="product-category">
          <div v-for="subcate in generateSubCategories()" :key="subcate" class="category-list v4">
            <h4 :id="replaceSpecials(subcate)" class="product-category-title">
              {{ subcate }}
            </h4>
            <div class="product-list product-list-troy grid-list">
              <div v-for="(p, index) in filterProductByYearAndCategoryAndSub(subcate)" :key="p" class="each-v4" :class="[{ active: matchIndexWithGroup(currentProducts.focus, index, subcate) }]">
                <div class="info" @click="[focusItemWithGroup(index, subcate), scrollToElementWithDelay('.detailcontent','smooth')]">
                  <div class="img">
                    <img :src="generateImgPath(p.productImage)" :alt="p.productName" />
                  </div>
                  <div class="icon">
                    <img v-if="checkMips(p.productNewFlag)" :src="generateIconImgPath('MIPS.png')" alt="mips" />
                    <img v-if="checkD3o(p.productNewFlag)" :src="generateIconImgPath('D3O.jpg')" alt="d30" />
                  </div>
                  <div class="product-name-v4">
                    <span v-if="checkNew(p.productNewFlag)" class="new-box"> NEW </span>
                    {{ p.productName }} <br />{{ p.productColor }}
                  </div>
                  <p class="price-v4">
                    <span v-html="formatYen(p.productPrice)" />
                    <span class="jp">（税込）</span>
                  </p>
                </div>
                <template v-if="matchIndexWithGroup(currentProducts.focus, index, subcate)">
                  <DetailPanel :keyindex="index" :brand-info="brandInfo" :close-action="closePanel" :focus="currentProducts.focus" :product="p" :year="v3year" types="v3" />
                </template>
              </div>
            </div>
          </div>
        </section>

        <section v-else class="product-category">
          <div class="product-list product-list-sdg v3">
            <div v-for="(p, index) in filterProductByYearAndCategory()" :key="p" class="each-v4" :class="[{ active: matchIndex(index, currentProducts.focus) }]">
              <div class="info" @click="[focusItem(index), scrollToElementWithDelay('.detailcontent','smooth')]">
                <div class="img">
                  <img :src="generateImgPath(p.productImage)" :alt="p.productNameJ" />
                </div>
                <div class="product-name-v3">
                  <span v-if="p.productNewFlag" class="new-box"> NEW </span>
                  {{ p.productName }}
                </div>
                <p class="price-v3">
                  <span v-html="formatYen(p.productPrice)" />
                  <span class="jp">（税込）</span>
                </p>
              </div>
              <template v-if="matchIndex(currentProducts.focus, index)">
                <DetailPanel :keyindex="index" :brand-info="brandInfo" :close-action="closePanel" :focus="currentProducts.focus" :product="p" :year="v3year" types="v3" />
              </template>
            </div>
          </div>
        </section>

        <ExtendProductVideo :my-products="filterProductByYearAndCategory()" />

        <div class="mt-12 sm:mt-14 md:mt-16 lg:mt-20">
          <Link class="w-auto" :href="`/brands/${brandInfo[0].brandSlug}#brand-products`">
            <button class="block text-[13px] sm:text-[14px] py-4">
              <Icon type="arrow" class="scale-x-[-1] inline-block -mt-[2px] mr-[2px]" />
              商品一覧のトップに戻る
            </button>
          </Link>
        </div>
      </div>
    </div>
  </div>
</template>
